import React, { useRef, useState } from 'react'
import styles from './styles.module.scss'

const DIRECTION = Object.freeze({
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
})

const { LEFT, RIGHT } = DIRECTION

const ALIGNMENT = Object.freeze({
  TOP: 'center',
  RIGHT: '',
  BOTTOM: 'center',
  LEFT: 'right',
})

const calculateCoordinates = node => {
  const documentWidth = document.documentElement.clientWidth
  const screenWidth = window.innerWidth

  const rightSideWidth =
    node.getBoundingClientRect().right + node.lastChild.clientWidth

  const useLeft = rightSideWidth > documentWidth && rightSideWidth > screenWidth

  const coordinates = {}
  coordinates.display = true

  if (useLeft) {
    coordinates.direction = LEFT
    return coordinates
  }
  coordinates.direction = RIGHT
  return coordinates
}
const Tooltip = props => {
  const [coordinates, setCoordinates] = useState()
  const ref = useRef()

  const mouseEvent = event => {
    if (event?.type === 'mouseleave') {
      setCoordinates(null)
      return
    }
    setCoordinates(calculateCoordinates(ref.current))
  }

  const visibility = coordinates?.display ? 'visible' : 'hidden'

  return (
    <div
      className={styles.tooltipWrapper}
      style={{
        justifyContent:
          coordinates?.direction === LEFT ? ALIGNMENT.LEFT : ALIGNMENT.RIGHT,
      }}
      ref={ref}
      role="button"
      onMouseEnter={mouseEvent}
      onMouseLeave={mouseEvent}
      aria-hidden
    >
      {props.children}
      <div
        className={coordinates?.direction === LEFT ? styles.left : styles.right}
        style={{
          visibility,
        }}
      >
        {props.content}
      </div>
    </div>
  )
}

export default Tooltip
